import { Component } from '@angular/core'
import { FileDataService } from '../commons/file-data.service'
import { Project } from '4d-mapper'
import { Subscription, } from 'rxjs'


@Component({
    selector:'project_picker-comp',
    templateUrl:'./project_picker.component.html',
    styleUrls:['./main.component.scss']

})
export class ProjectPickerComponent{

    projects:any
    
    constructor(public fileManager:FileDataService) {
        this.projects = fileManager.projects.state
    }
  

}
